import { SPEC_ROWS } from "@/data/products";
import Reveal from "@/components/site/Reveal";

export default function SpecSheet() {
  return (
    <section className="section-dark" data-testid="spec-sheet">
      <Reveal>
        <div className="section-head">
          <span className="mono-tag mono-tag-dark">02 / SPEC SHEET</span>
          <h2 className="section-title section-title-dark">SIZES &amp; GRADES</h2>
        </div>
      </Reveal>

      <Reveal delay={0.1}>
      <div className="spec-table-wrap">
        <table className="spec-table">
          <thead>
            <tr>
              <th>SECTION</th>
              <th>SIZES COMMONLY STOCKED</th>
              <th>GRADE / STANDARD</th>
            </tr>
          </thead>
          <tbody>
            {SPEC_ROWS.map(([a, b, c]) => (
              <tr key={a} data-testid={`spec-row-${a.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
                <td>{a}</td>
                <td>{b}</td>
                <td>{c}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <p className="spec-note">
        * OTHER SIZES ON INDENT. MILL TEST CERTIFICATE AVAILABLE ON REQUEST.
        CONFIRM AVAILABILITY ON WHATSAPP BEFORE DISPATCH.
      </p>
      </Reveal>
    </section>
  );
}
